import React, { Component } from "react";
import { ModalToolbar, Overlay } from "src/views/shared/components";
import * as styles from "./Modal.module.scss";

export interface ModalProps {
  padding?: boolean;
  open: boolean;
  onClose: () => void;
  title?: string;
  className?: string;
}

export class Modal extends Component<ModalProps> {
  render() {
    const { children, className, open, onClose, padding, title } = this.props;

    if (!open) {
      return null;
    }

    const wrapperClasses = [styles.wrapper];
    if (padding) {
      wrapperClasses.push(styles.padding);
    }

    if (className) {
      wrapperClasses.push(className);
    }
    return (
      <Overlay>
        <div className={wrapperClasses.join(" ")}>
          <ModalToolbar title={title} onClose={onClose} />
          {children}
        </div>
      </Overlay>
    );
  }
}
